import React, { useReducer, useContext, createContext, Dispatch } from 'react'
import { SUPPORTED_COLORS } from '../constants/canvas'

export type SketchTool = 'select' | 'pencil' | 'arrow' | 'circle' | 'line' | 'rectangle' | 'pan'

interface SketchState {
  color: string
  scale: number
  tool: SketchTool
}

type SketchAction =
  | { type: 'SET_COLOR'; value: string }
  | { type: 'SET_SCALE'; value: number }
  | { type: 'SET_TOOL'; value: SketchTool }

const initialValue: SketchState = {
  color: SUPPORTED_COLORS.black,
  scale: 0.7,
  tool: 'pencil',
}

const SketchStateContext = createContext<SketchState>(initialValue)
const SketchDispatchContext = createContext<Dispatch<SketchAction> | null>(null)

const reducer = (state: SketchState, action: SketchAction): SketchState => {
  switch (action.type) {
    case 'SET_COLOR':
      return {
        ...state,
        color: action.value,
      }
    case 'SET_SCALE':
      return {
        ...state,
        scale: action.value,
      }
    case 'SET_TOOL':
      return {
        ...state,
        tool: action.value,
      }
    default:
      throw new Error('Unknown action')
  }
}

export const SketchProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialValue)
  return (
    <SketchDispatchContext.Provider value={dispatch}>
      <SketchStateContext.Provider value={state}>{children}</SketchStateContext.Provider>
    </SketchDispatchContext.Provider>
  )
}

export const useSketch = () => useContext(SketchStateContext)
export const useDispatchSketch = () => useContext(SketchDispatchContext)
